'use client';

import React from 'react';
import { interestHref } from '../common/constants';

import { useGlobalClientContext } from '../common/GlobalClientContext';

export default function Bottom() {
  const {
    i18nHelper: { t }
  } = useGlobalClientContext();

  return (
    <div className="w-full h-fit bg-gray-900 py-10xl flex flex-col items-center justify-center">
      <div className="font-display font-semibold text-3xl leading-8xl text-primaryInverse">
        {t('public.site.solution.bottom.title', {})}
      </div>
      <div className="mt-l !font-regular text-xl leading-3xl text-primaryInverse text-center w-[950px]">
        {t('public.site.solution.bottom.description', {})}<br />
        {t('public.site.solution.bottom.description1', {})}
      </div>
      <a
        href={interestHref}
        className="h-[48px] mt-[32px] bg-[#05a8fd] w-fit rounded-[8px] hover:bg-[#0497E4] hover:no-underline active:bg-[#0686C8] px-xl py-m font-display font-semibold text-md leading-sm text-primaryInverse">
        {t('public.site.solution.bottom.button', {})}
      </a>
    </div>
  );
}
